import { createApp } from 'vue'
import App from './App.vue'
import './assets/css/general.css'
import './assets/css/universal.css'

createApp(App).mount('#app')
